import api from "app/lib/api";
import endpoints from "static/endpoints";

const convertToCSV = (data) => {
  if (!data || data.length === 0) return "";

  const headers = [
    "Report Id",
    "Patient Id",
    "Name",
    "First Name",
    "Last Name",
    "Middle Initial",
    "Account",
    "DOB",
    "MRN",
    "Gender",
    "Email",
    "Phone 1",
    "Phone 2",
    "Street 1",
    "Street 2",
    "City",
    "State",
    "Zip",
    "Evoke Id",
    "Manufacturer",
    "Billing Codes",
    "Diagnosis Codes",
    "Clean Code",
    "Device Category",
    "Device",
    "Report Date",
    "Report Billing Date",
    "Last Billing Date",
    "Day Count",
    "Billing Status",
    "Archived",
    "Insurance",
    "Clinician",
    "Clinic Billed",
    "Billable",
    "IDTF",
    "Address",
  ];
  const csvContent = [headers.join(",")];

  data.forEach((row) => {
    const csvRow = headers.map((header) => {
      const value = row[header] ?? "";
      return `"${value}"`;
    });
    csvContent.push(csvRow.join(","));
  });

  return csvContent.join("\n");
};

export const downloadBillingReport = async (payload) => {
  const { startDate, endDate } = payload;
  const url = `${endpoints.benchmarkBilling.search}?startDate=${startDate}&endDate=${endDate}`;

  const response = await api.get(url);
  const csvContent = convertToCSV(response.data);
  const blob = new Blob([csvContent], { type: "text/csv" });
  const filename = `billing-report-${startDate}-${endDate}.csv`;
  const count = response.count;

  return { data: blob, filename, count };
};
